import { ENUM_EMBED_HOSTNAME } from '../../enums/embed-hostname.enum';
const VENDORS = [
    { host: ENUM_EMBED_HOSTNAME.YOUTUBE, label: 'YouTube' },
    { host: ENUM_EMBED_HOSTNAME.YOUTU_BE, label: 'YouTube' },
    { host: ENUM_EMBED_HOSTNAME.INSTAGRAM, label: 'Instagram' },
    { host: ENUM_EMBED_HOSTNAME.THREADS, label: 'Threads' },
    { host: ENUM_EMBED_HOSTNAME.TIKTOK, label: 'TikTok' },
    { host: ENUM_EMBED_HOSTNAME.TWITTER, label: 'X' },
    { host: ENUM_EMBED_HOSTNAME.FACEBOOK, label: 'Facebook' },
    { host: ENUM_EMBED_HOSTNAME.LINKEDIN, label: 'LinkedIn' },
    { host: ENUM_EMBED_HOSTNAME.PINTEREST, label: 'Pinterest' },
    { host: ENUM_EMBED_HOSTNAME.BLUESKY, label: 'Bluesky' },
    { host: ENUM_EMBED_HOSTNAME.MASTODON, label: 'Mastodon' },
    { host: ENUM_EMBED_HOSTNAME.REDDIT, label: 'Reddit' },
    { host: ENUM_EMBED_HOSTNAME.CALENDLY, label: 'Calendly' },
    { host: ENUM_EMBED_HOSTNAME.CAL, label: 'Cal.com' },
    { host: ENUM_EMBED_HOSTNAME.ZCAL, label: 'zcal' },
    { host: ENUM_EMBED_HOSTNAME.SPOTIFY, label: 'Spotify' },
    { host: ENUM_EMBED_HOSTNAME.GOOGLE_MAPS_SHORT, label: 'Google Maps' },
    { host: ENUM_EMBED_HOSTNAME.GOOGLE_MAPS, label: 'Google Maps' },
];
const SCRIPT_TAG = /<script\b/i;
const REMOTE_SRC = /<(?:script|iframe|embed|object)\b[^>]*\b(?:src|data)\s*=\s*["']((?:https?:)?\/\/[^"']+)["']/i;
const hostnameOf = (url) => {
    try {
        return new URL(url.startsWith('//') ? `https:${url}` : url).hostname.replace(/^www\./, '') || null;
    }
    catch (_a) {
        return null;
    }
};
export const getEmbedVendor = (html) => {
    var _a;
    if (!html)
        return null;
    const known = VENDORS.find((vendor) => html.includes(vendor.host));
    if (known)
        return known;
    const remote = (_a = html.match(REMOTE_SRC)) === null || _a === void 0 ? void 0 : _a[1];
    const host = remote ? hostnameOf(remote) : null;
    if (host)
        return { host, label: host };
    if (SCRIPT_TAG.test(html))
        return { host: '', label: null };
    return null;
};
export const hasThirdPartyEmbed = (html) => getEmbedVendor(html) !== null;
//# sourceMappingURL=get-embed-vendor.js.map